/// <amd-module name="TFS/Views/SuiteMePage/SuiteMePageView/InstalledProducts" />
import React = require("react");

import { ContributedFeature } from "TFS/FeatureManagement/Contracts/FeatureManagement";
import * as SuiteMePageResources from "TFS/Views/SuiteMePage/Resources";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation, routeUrl } from "VSS/Platform/Location";
import { FocusZoneContext, IFocusZoneContext } from "VSSUI/FocusZone";
import { Image } from "VSSUI/Image";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";

export interface InstalledProductsProps {
    products: ContributedFeature[];
    projectName: string;
}

export class InstalledProductsComponent extends VssComponent<InstalledProductsProps, {}> {
    public render(): JSX.Element {
        return (
            <FocusZoneContext.Consumer>
                {(focusContext) => <div className="flex-row installed-product flex-end">{this.getProductComponents(focusContext)}</div>}
            </FocusZoneContext.Consumer>
        );
    }

    private getProductComponents(focusContext: IFocusZoneContext): JSX.Element[] {
        const productComponents: JSX.Element[] = [];
        if (this.props.products && this.props.products.length) {
            let delay = 0;
            this.props.products.sort((a, b) => a.order - b.order);
            this.props.products.forEach((product) => {
                delay += 30;
                productComponents.push(this.onRenderProduct(product, delay, focusContext));
            });
        }
        return productComponents;
    }

    private onRenderProduct(product: ContributedFeature, delay: number, focusContext: IFocusZoneContext): JSX.Element {
        const iconAsset = product && product._links && product._links["icon"];
        const iconUrl = iconAsset && getAssetLocation(this.context.pageContext, iconAsset.href);

        // TODO: Only do this on hover so that we don't call routeUrl for 5 times per project on initial render
        let url = undefined;
        const routeId = product.featureProperties && product.featureProperties["defaultRoute"];
        if (routeId) {
            try {
                url = routeUrl(this.context.pageContext, routeId, { project: this.props.projectName });
            } catch {
                /*If for some reason we didn't have the route in shared data, we don't want to not load the page*/
            }
        }

        let content = (
            <>
                <div className="placeholder" />
                <div className={css("product-image-container", "animation-delay-" + delay)}>
                    <div className="flex-row link-icon">
                        <Image alt="" className="product-image" src={iconUrl} />
                    </div>
                </div>
            </>
        );

        content = url ? (
            <a
                className="product"
                href={url}
                tabIndex={-1}
                data-focuszone={focusContext.focuszoneId}
                aria-label={format(SuiteMePageResources.InstalledProductAriaLabel, product.name, this.props.projectName)}
            >
                {content}
            </a>
        ) : (
            <div className="product">{content}</div>
        );

        return <Tooltip key={product.id}>{content}</Tooltip>;
    }
}
